{
  "version": 1,
  "asset_id": "cabc9ea1-c243-4a33-b14b-be568eda7d8c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cabc9ea1-c243-4a33-b14b-be568eda7d8c/sleeve-ugi-dilated-1448.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cabc9ea1-c243-4a33-b14b-be568eda7d8c/sleeve-ugi-dilated-1448.webp",
  "original_filename": "sleeve-ugi-dilated-1448.webp",
  "size": 68714,
  "content_type": "image/webp",
  "created_at": "2026-09-28T01:31:10Z"
}
